import { PageableSearchResult, SearchResult } from "@scrile/api-provider/dist/api/types";

export const getAllPageableData = async <T, I extends PageableSearchResult & SearchResult<T>>(
  cb: (page: number) => Promise<I>,
  page = 0
): Promise<I> => {
  const currentRes = await cb(page);
  if (currentRes.hasNextPage) {
    const nextRes = await getAllPageableData(cb, page + 1);
    nextRes.result = currentRes.result.concat(nextRes.result);
    return nextRes;
  }
  return currentRes;
};
